import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { allergies } from '../models/allergies-options';

@Component({
  selector: 'app-patient-allergies',
  templateUrl: './patient-allergies.component.html',
  styleUrl: './patient-allergies.component.scss'
})
export class PatientAllergiesComponent implements OnInit {

  protected allergiesList: any[] = [];
  protected selectedCategory: any;
  protected selectedType: any;

  protected categoryValid: boolean = false;
  protected typeValid: boolean = false;


  constructor(public dialogRef: MatDialogRef<PatientAllergiesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      includeOrUpdate: 'include' | 'update',
      patientAllergies: any[],
      mandatory: boolean
    }) { }

  ngOnInit() {
    // this.allergiesList = this.data.patientAllergies;
    this.allergiesList = allergies;
  }

  checkCategory(category: any) {
    if (category.selected) {
      category.selected = false;
      category.allergyType.forEach((item: any) => { item.selected = false });
      this.selectedType = null;

      const firstSelectedValue = this.allergiesList.find(item => item.selected);
      if (firstSelectedValue) {
        this.selectedCategory = firstSelectedValue;
      }
      else {
        this.selectedCategory = null;
      }
    }
    else {
      category.selected = true;
      if (this.selectedCategory && this.selectedCategory.allergyCategory === category.allergyCategory) {

      }
    }

    this.selectedCategory = category;
    this.isTypeValid();
  }

  checkType(type: any) {
    if (type.selected) {
      type.selected = false;

      const firstSelectedValue = this.selectedCategory.find((item: any) => item.selected);
      if (firstSelectedValue) {
        this.selectedType = firstSelectedValue;
      }
      else {
        this.selectedType = null;
      }
    }
    else {
      type.selected = true;
      this.selectedType = type;
    }

    this.isTypeValid();
  }

  isTypeValid() {
    this.selectedCategory.forEach((item: any) => {
      if (item.selected) {
        const types = item.allergyType.find((subItem: any) => subItem.selected);
        if (types) {
          this.typeValid = true;
        }
        else {
          this.typeValid = false;
        }
      }
      else {
        this.typeValid = false;
      }
    });
  }

  onSubmitForm() {
    console.log(this.allergiesList);
    // this.dialogRef.close({ action: this.data.includeOrUpdate });
  }

  onCancelForm() {
    this.dialogRef.close({ action: 'cancel' });
  }
}
